export default __webpack_public_path__ + "static/media/success.848117d5.png";